import * as Yup from 'yup';

import { mobileNumberValidation } from '../utils/Validations';

export const RegisterSchema = Yup.object().shape({
  firstName: Yup.string().required('First name required'),
  lastName: Yup.string().required('Last name required'),
  phoneNumber: Yup.string().required('Phone number required').matches(mobileNumberValidation, 'Number must be valid BD number'),
  email: Yup.string().email('Email must be a valid email address').required('Email is required'),
  password: Yup.string().required('Password is required'),
});

export const OtpSchema = Yup.object().shape({
  otp: Yup.string()
    .required('OTP is required')
    .matches(/^[0-9]+$/, 'Must be number')
    .min(6, 'Must be exactly 6 digits')
    .max(6, 'Must be exactly 6 digits'),
});

export const LoginSchema = Yup.object().shape({
  email: Yup.string().email('Email must be valid').required('Email is required'),
  password: Yup.string().required('Password is required'),
});

export const ProfileSchema = Yup.object().shape({
  firstName: Yup.string().required('First name is required'),
  lastName: Yup.string().required('Last name is required'),
  email: Yup.string().email('Email must be valid').required('Email is required'),
  phone: Yup.string().required('Phone number is required').matches(mobileNumberValidation, 'Number must be valid BD number'),
});

export const ContactSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  email: Yup.string().email('Email must be valid').required('Email is required'),
  requestType: Yup.string().required('Request type is required'),
  details: Yup.string().required('Details message is required'),
});

export const ReplySchema = Yup.object().shape({
  details: Yup.string().required('Message is required'),
});
